import { Warning } from '@mui/icons-material';
import { FormattedMessage } from 'react-intl';
import { PATHS } from '../../config/consts';
import { TId } from '../../modules/commonTypes';
import Alert from '../Alert';
import Link from '../Link';
import messages from './messages';

interface IDormakabaModalPinAlert {
  companyId: TId;
  displayIcon?: boolean;
  isApartmentAdmin?: boolean;
  siteId: TId;
}

function DormakabaModalPinAlert({ companyId, displayIcon, isApartmentAdmin, siteId }: IDormakabaModalPinAlert) {
  const message = isApartmentAdmin ? messages.apartmentAdmin : messages.siteAdmin;

  return (
    <Alert icon={displayIcon ? <Warning /> : undefined} severity="warning">
      <FormattedMessage
        {...message}
        values={{
          br: <span style={{ display: 'block', marginBottom: '8px' }} />,
          link: (chunks) => (
            <Link
              to={PATHS.SITE_SETTINGS_ACCESS.replace(':companyId', companyId.toString()).replace(
                ':siteId',
                siteId.toString()
              )}
            >
              {chunks}
            </Link>
          ),
          strong: (chunks) => <strong>{chunks}</strong>,
        }}
      />
    </Alert>
  );
}

export default DormakabaModalPinAlert;
